var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t("dashboard.bytesHistogram.title"))+" ")]),_c('v-card-text',[_c('v-row',[_c('Bar',{staticStyle:{"width":"100%"},attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"height":_vm.chartHeight}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }